module.exports = __webpack_public_path__ + "img/top1.879ed029.png";